import Vue from 'vue'
import Vuex from 'vuex'
import LoadScript from 'vue-plugin-load-script'
import { concat } from '@/utils/stringUtils'

Vue.use(Vuex)
Vue.use(LoadScript)

const getDefaultState = () => {
  return {
    mode: 0,
    tab: 0,
    fileId: 0,
    apiConfig: {
      jsUrl: process.env.VUE_APP_CANADAPOST_JS_URL,
      cssUrl: process.env.VUE_APP_CANADAPOST_CSS_URL,
      key: process.env.VUE_APP_CANADAPOST_APIKEY
    },
    address: {
      line1: '',
      line2: '',
      city: '',
      province: '',
      provinceCode: '',
      postalCode: '',
      countryName: ''
    },
    startUp: false,
    callbacks: []
  }
}

const state = getDefaultState()

const getters = {
  getTab: (state) => { return state.tab },
  getFileId: (state) => { return state.fileId },
  getApiCssUrl: (state) => { return state.apiConfig.cssUrl },
  getApiJsUrl: (state) => { return state.apiConfig.jsUrl },
  getApiKey: (state) => { return state.apiConfig.key },
  oneLineAddress: (state) => {
    return concat(state.address.line1, state.address.line2, ' ')
  },
  addressData: (state) => {
    return state.address
  },
  getAddressToDTO: (state) => {
    // TO DO : Adapt this to RenseignementGeneraux
    let address = {}
    address.line1 = state.address.line1
    address.line2 = state.address.line2
    address.city = state.address.city
    address.province = state.address.province
    address.provinceCode = state.address.provinceCode
    address.postalCode = state.address.postalCode
    address.countryName = state.address.countryName
    return address
  }
}

const mutations = {
  setTab(state, tab) {
    state.tab = tab
  },
  setFileId(state, fileId) {
    state.fileId = fileId
  },
  loadAddressFromDTO(state, address) {
    // fill from dto
    state.address.line1 = address.line1
    state.address.line2 = address.line2
    state.address.city = address.city
    state.address.province = address.province
    state.address.provinceCode = address.provinceCode
    state.address.postalCode = address.postalCode
    state.address.countryName = address.countryName
  },
  loadAddressFromCanadaPost(state, address) {
    // Fill to renseignement generaux
    state.address.line1 = address.Line1
    state.address.line2 = address.Line2
    state.address.city = address.City
    state.address.province = address.Province
    state.address.provinceCode = address.ProvinceCode
    state.address.postalCode = address.PostalCode
    state.address.countryName = address.CountryName
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  initialiseModule ({state, getters, dispatch}, {component, callback}) {

    state.callbacks.push(callback)

    // Import unique de CanadaPost
    if (state.startUp) {
      return
    }

    state.startUp = true
    dispatch('addCanadaPostApiCss')
    dispatch('safeLoadScript', {url: getters.getApiJsUrl, component: component})
        .then(() => {
          console.log('Chargement réussi de ' + getters.getApiJsUrl)
          state.callbacks.forEach(callback => {
            callback()
          })
          state.startUp = false
        })
        .catch((err) => {
          console.log(err)
          state.startUp = false
        })
  },
  addCanadaPostApiCss ({getters}) {
    const cssLink = document.createElement('link')
    cssLink.setAttribute('rel', 'stylesheet')
    cssLink.setAttribute('href', getters.getApiCssUrl)
    document.head.appendChild(cssLink)
  },
  safeLoadScript ({getters}, {url, component}) {
    console.log('Tentative de chargement de ' + url)
    return component.$loadScript(url)
  },
  resetModuleState ({commit}) {
    commit('resetState')
  },
}

export default ({
  strict: true,
  namespaced: true,
  state,
  getters,
  mutations,
  actions
})